/**
 * Report base class
 */
class Report {

    name      = '';
    title     = '';

    app       = null;
    apiCaller = null;

    /**
     * Constructor
     * 
     * @param {Ractive} ractive - Ractive instance
     */
    constructor(ractive, apiCaller) {
        this.app       = ractive;
        this.apiCaller = apiCaller;
    }

    /**
     * Overloaded method:
     * Registers all the routes that the report will handle
     * 
     * @return {void}
     */
    registerRoutes() {}

    /**
     * Overloaded method:
     * Method called after data processing
     * 
     * @return {void}
     */
    assemble() {}

    /**
     * Overloaded method:
     * Initialize the report
     * 
     * @param {object} context - Context object
     */
    setReport(context) {
        this.app.initializeReport(this.name, this.title);
        console.debug('#page – path', context.path, 'with parameters of', context.params);
    };
}

module.exports = Report;